import { render, staticRenderFns } from "./KnowledgeQuestionPractice.vue?vue&type=template&id=779c76a7&scoped=true"
import script from "./KnowledgeQuestionPractice.vue?vue&type=script&lang=js"
export * from "./KnowledgeQuestionPractice.vue?vue&type=script&lang=js"
import style0 from "./KnowledgeQuestionPractice.vue?vue&type=style&index=0&id=779c76a7&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "779c76a7",
  null
  
)

export default component.exports